import styled from 'styled-components';

import media from '../../styles/media.style';
import { SCREEN_LOCKUP_WIDTH, MOBILE_PADDING } from '../../styles/variables.style';

export const VisionSection = styled.section`
  margin: 30px auto 30px;
  padding-top: 20px;

  ${media.tabletL`
    margin: 80px auto 60px;
    padding-top: 40px;
  `};
`;

export const VisionTitle = styled.div`
  font-size: 34px;
  font-weight: 500;
  line-height: 1.11;
  letter-spacing: 0.5px;
  text-align: center;
  margin: 0 auto;
  max-width: 715px;
  width: 100%;

  ${media.tabletL`
    font-size: 48px;
    line-height: 1;
    letter-spacing: 0.6px;
  `};
`;

export const VisionDescription = styled.div`
  font-size: 14px;
  line-height: 1.36;
  letter-spacing: 0.1px;
  color: #333333;
  text-align: center;
  margin: 25px auto 0;
  max-width: 715px;
  width: 100%;

  ${media.tabletL`
    font-size: 18px;
    line-height: 1.39;
    letter-spacing: 0.1px;
  `};
`;

export const Gallery = styled.div`
  margin-top: 25px;
  width: 100%;

  ${media.tabletL`
    margin-top: 60px;  
  `};
`;

export const Slide = styled.div`
  margin: 0 auto;
  max-width: ${SCREEN_LOCKUP_WIDTH + MOBILE_PADDING * 2}px;
  padding: ${MOBILE_PADDING}px;
  width: 100%;

  ${media.tabletL`
    display: flex;
  `};
`;

export const ImageContainer = styled.div`
  ${media.tabletL`
    width: 70%;
  `};
`;

export const Artist = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;

  &:first-child {
    margin-top: 0;
  }

  ${media.tabletL`
    padding-left: 20px;
    width: 30%;
  `};
`;

export const ArtistImage = styled.div`
  margin-top: 20px;
  width: 40%;

  ${media.tabletL`
    margin-top: 0;
    width: 100%;
  `};
`;

export const ArtistQuote = styled.div`
  color: #333333;
  font-size: 20px;
  font-weight: 500;
  font-style: oblique;
  line-height: 1;
  letter-spacing: 0.2px;
  margin: 20px 0 0 0;
  order: -1;
  text-align: center;
  width: 100%;

  ${media.tabletL`
    font-size: 28px;
    line-height: 1.25;
    letter-spacing: 0.3px;
    order: unset;
    text-align: left;
  `};
`;

export const ArtistDescription = styled.div`
  font-size: 14px;
  line-height: 1.25;
  letter-spacing: 0.1px;
  margin-top: 20px;
  text-align: center;
  width: 100%;

  ${media.tabletL`
    font-size: 18px;
    line-height: 1.33;
    letter-spacing: 0.1px;
    margin-left: 15px;
    text-align: left;
  `};
`;

export const ArtistNameAndTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  ${media.tabletP`
    margin-left: 15px;
    margin-top: 10px;
  `};
`;

export const ArtistTitle = styled.div`
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.1px;
  margin-top: 5px;
  text-align: center;

  ${media.tabletL`
    align-self: flex-start;
    font-size: 18px;
    line-height: 1.33;
    margin-top: 10px;
    text-align: left;
  `};
`;

export const ArtistName = ArtistTitle.extend`
  font-weight: bold;
  margin-top: 15px;

  ${media.tabletL`
    margin-top: 25px;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/AboutPage/OurVisionSection.style.js